module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.chartMethod == 1
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.chartMethod = 1
      }
    }
  }, [_c('a', [_vm._v("行銷統計\n              ")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.chartMethod == 2
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        _vm.chartMethod = 2
      }
    }
  }, [_c('a', [_vm._v("各店統計\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row form-inline m-b-10"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('div', {
    staticClass: "from-group inline-block pull-left"
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title h-38",
    on: {
      "click": _vm.reportPromotion
    }
  }, [_vm._v("產生報表")])]), _vm._v(" "), (_vm.storeBrief.length > 1 && _vm.chartMethod === 2) ? _c('div', {
    staticClass: "inline-block from-group pull-left m-l-5",
    staticStyle: {
      "width": "auto",
      "min-width": "150px"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "label": "label",
      "searchable": false,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "門市",
      "show-labels": false,
      "preselect-first": true
    },
    on: {
      "input": _vm.changeSelect
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('div', {
    staticClass: "form-group input-group time-box pull-right"
  }, [_c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.dateoption,
      "limit": _vm.startLimit
    }
  }), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.dateoption,
      "limit": _vm.endLimit
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default submit-btn btn-search",
    staticStyle: {
      "height": "72px"
    },
    attrs: {
      "type": "button",
      "id": "search"
    },
    on: {
      "click": function($event) {
        return _vm.search(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-all bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 1
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 1
      }
    }
  }, [_vm._v("\n                    累積\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-basic bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 2
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 2
      }
    }
  }, [_vm._v("\n                    期間\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn-gb bg-primary btn-detail-edit p-10",
    class: {
      'active': _vm.typeSelect !== 3
    },
    on: {
      "click": function($event) {
        _vm.typeSelect = 3
      }
    }
  }, [_vm._v("\n                    目前\n                  ")])])])])]), _vm._v(" "), (_vm.chartMethod === 1) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', {
    staticClass: "middle"
  }, [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已折")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折抵中")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("作廢")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("逾期")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'give_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'used_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'using_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'void_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('valid_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'valid_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('exp_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'exp_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "middle"
  }, _vm._l((_vm.promotionList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 15px",
        "background": "#efefef",
        "border-radius": "6px",
        "min-width": "320px"
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('h4', [_vm._v(_vm._s(coupon.coupon_set_name))]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(coupon.coupon_set_description))])]), _vm._v(" "), _c('p', {
      staticClass: "text-blue"
    }, [_c('small', [_vm._v("•  " + _vm._s(_vm.getItemType(coupon.get_item_type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [(coupon.discount_type === 1) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        $ " + _vm._s(coupon.discount_value) + "\n                      ")]) : _vm._e(), _vm._v(" "), (coupon.discount_type === 2) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s((100 - coupon.discount_value) / 10) + " 折\n                      ")]) : _vm._e()])])]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  " + _vm._s(coupon.valid_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.valid_coupon_money) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  " + _vm._s(coupon.exp_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.exp_coupon_money) + "\n                ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.chartMethod === 2) ? _c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', {
    staticClass: "middle"
  }, [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("優惠券")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "2",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("門市")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("贈送")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("已折")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("折抵中")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "3",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("作廢")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("有效")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "2",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("逾期")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'give_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('give_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'give_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'used_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('used_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'used_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'using_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('using_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'using_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_order_amount')
      }
    }
  }, [_vm._v("訂單\n                  "), (_vm.sortMethod === 'void_order_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('void_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'void_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('valid_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'valid_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    staticClass: "c-pointer",
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('exp_coupon_amount')
      }
    }
  }, [_vm._v("張數\n                  "), (_vm.sortMethod === 'exp_coupon_amount') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("金額")]) : _vm._e()])]), _vm._v(" "), _c('tbody', {
    staticClass: "middle"
  }, _vm._l((_vm.storeCouponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 15px",
        "background": "#efefef",
        "border-radius": "6px",
        "min-width": "320px"
      }
    }, [_c('div', {
      staticClass: "coupon-left"
    }, [_c('h4', [_vm._v(_vm._s(coupon.coupon_set_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(coupon.coupon_set_description))])]), _vm._v(" "), _c('div', {
      staticClass: "coupon-right"
    }, [(coupon.discount_type === 1) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        $ " + _vm._s(coupon.discount_value) + "\n                      ")]) : _vm._e(), _vm._v(" "), (coupon.discount_type === 2) ? _c('p', {
      staticClass: "v-middle"
    }, [_vm._v("\n                        " + _vm._s((100 - coupon.discount_value) / 10) + " 折\n                      ")]) : _vm._e()])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.store_name) + " (" + _vm._s(coupon.store_id) + ")")]), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.give_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-success"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.give_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.used_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-warning"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.used_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.using_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-primary"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.using_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_order_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v(_vm._s(coupon.void_coupon_amount_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect !== 3) ? _c('td', {
      staticClass: "td-danger"
    }, [(_vm.typeSelect === 1) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money))]) : (_vm.typeSelect === 2) ? _c('span', [_vm._v("$ " + _vm._s(coupon.void_coupon_money_seg))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  " + _vm._s(coupon.valid_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-success"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.valid_coupon_money) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  " + _vm._s(coupon.exp_coupon_amount) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.typeSelect === 3) ? _c('td', {
      staticClass: "td-danger"
    }, [_vm._v("\n                  $ " + _vm._s(coupon.exp_coupon_money) + "\n                ")]) : _vm._e()])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('pre')
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('left')
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.pageAmount), function(index) {
    return (_vm.pageShow(index)) ? _c('li', {
      staticClass: "paginate_button",
      class: {
        active: _vm.isActive(index)
      },
      on: {
        "click": function($event) {
          return _vm.clickPage(index)
        }
      }
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v(_vm._s(index))])]) : _vm._e()
  }), _vm._v(" "), _vm._l(((_vm.groupAmount - Math.ceil(_vm.pageAmount % 10))), function(dis) {
    return (_vm.pageGroup === Math.ceil(_vm.pageAmount / _vm.groupAmount)) ? _c('li', {
      staticClass: "paginate_button disabled"
    }, [_c('a', {
      staticClass: "c-pointer"
    }, [_vm._v("  ")])]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickGroup('right')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "paginate_button",
    on: {
      "click": function($event) {
        return _vm.clickEnd('forward')
      }
    }
  }, [_vm._m(3)])], 2)])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delMOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delAOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleGNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.removeNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.saleNowOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-backward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "c-pointer"
  }, [_c('i', {
    staticClass: "fa fa-step-forward",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c6c72a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/CouponChart.vue
// module id = 2431
// module chunks = 1